import { fetchWrapper, handleResponse, hcUrl, buildOpts } from 'services/RequestService/helpers';

const getPromotions = async () => {
  const response = await fetchWrapper(hcUrl('/home/promotions'), buildOpts());
  return handleResponse(response);
};

export { getPromotions };
